import * as React from 'react';
import { MultiAppAuthenticationError } from '../../styles';
import { I18n, Translate } from 'react-redux-i18n';
import { InputName } from '..';
import { AuthenticateFormInput, AuthenticationInputWrapper } from '../../../Authentication/styles';
import RevealButton from './ButtonReveal';
interface AuthenticationInputProps {
	value: string;
	errorMessage: string;
	name: InputName;
	onChange: (e: React.FormEvent<HTMLInputElement>, key: InputName) => void;
	autoFocus?: boolean;
}

interface MultiAppAuthenticationState {
	isPasswordVisible: boolean;
}

const getType = (name: InputName) => {
	switch (name) {
		case InputName.Login:
			return 'email';
		case InputName.Password:
			return 'password';
		case InputName.Phone:
			return 'tel';
		default:
			return 'text';
	}
};

export class MultiAppAuthenticationInput extends React.Component<AuthenticationInputProps, MultiAppAuthenticationState> {
	constructor(props: AuthenticationInputProps ) {
		super(props);
		this.state = {
			isPasswordVisible: false,
		};
	}

	handleRevealButtonClick = (): void => {
		const { isPasswordVisible } = this.state;
		this.setState({ isPasswordVisible: !isPasswordVisible });
	}

	render() {
		const { value, errorMessage, onChange, name, autoFocus } = this.props;
		const { isPasswordVisible } = this.state;
		let type = getType(name);
		if ( getType(name) === 'password' && isPasswordVisible ) {
			type = 'text';
		}
		return (
			<AuthenticationInputWrapper>
				{errorMessage &&
					<MultiAppAuthenticationError>
						<Translate value={errorMessage} />
					</MultiAppAuthenticationError>
				}
				<AuthenticateFormInput
					value={value}
					onChange={onChange}
					required={true}
					data-error={errorMessage ? errorMessage : undefined}
					type={type}
					ref={name === InputName.Login
						? (ref) => {
							if (ref) {
								ref.setAttribute('autocorrect', 'none');
								ref.setAttribute('autocapitalize', 'off');
								ref.setAttribute('spellcheck', 'false');
							}
						} : undefined
					}
					minLength={name === InputName.Password ? 6 : undefined}
					placeholder={I18n.t(`messages.placeholder_${name}`)}
					autoFocus={autoFocus}
					name={name}
				/>
				{ name === InputName.Password &&
					<RevealButton onClick={this.handleRevealButtonClick} />
				}
			</AuthenticationInputWrapper>
		);
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/Form/Input/index.tsx